import { Pipe, PipeTransform } from '@angular/core';
import {numberCompare, PropertiesQuery} from "common-shared";
import {map} from "rxjs/operators";
import {PropertyLineModel} from "../../properties/models/property-line.model";

@Pipe({
  name: 'sortByProperty'
})
export class SortByPropertyPipe implements PipeTransform {

  constructor(private propertiesQuery: PropertiesQuery) {
  }

  transform(lines: PropertyLineModel[]): any {
    return this.propertiesQuery.selectAll$.pipe(map(value => {
      return (lines || []).sort((a, b) => numberCompare(a, b, obj => value.find(p=>p.Id === obj.PropertyId).Sequence));
    }));
  }

}
